import React from 'react';
import * as firebase from 'firebase';
import _ from 'lodash';

import { Link } from 'react-router-dom';

import Head from '../../components/Head';
import JobCardHeader from '../../components/JobCardHeader';
import JobCardContent from '../../components/JobCardContent';
import UnpublishedJob from '../../components/UnpublishedJob';
import EmptyState from '../../components/EmptyState';
import LoggedOutCard from '../../components/LoggedOutCard';
// import Snack from '../../components/Snack'
// import ViewMoreFeedBtn from '../../components/ViewMoreFeedBtn'
import SkeletonCard from '../../components/SkeletonCard';
import UnauthorizedText from '../../components/UnauthorizedText';
import { Title } from '../../helper/consts';

import Fade from 'material-ui/transitions/Fade';

import {
	Button,
	CircularProgress,
	Card,
	CardActions,
	Divider,
	Tabs,
	Tab
} from 'material-ui';

const style = {
	loading: {
		alignSelf: 'center',
		width: '75px',
		height: '75px',
		marginTop: 'calc(50vh - 37.5px - 64px)'
	}
};

export default class MyApplications extends React.Component {
	constructor() {
		super();

		this.state = {
			archives: false
			// loggedIn:false,
			// authLoading:true,
			// loading:true,
			// archiveLoading:true,
			// snackStatus:false,
			// snackMessage:'',
			// getVolume:3,
			// getVolumeIncrement:1,
			// getVolumeArchives:3,
			// getVolumeIncrementArchives:1,
		};
	}

	componentWillUnmount() {
		this.props.uid &&
			this.props.loggedIn &&
			firebase
				.database()
				.ref(`myApplications/${this.props.user.uid}`)
				.off();
	}

	componentDidMount() {
		let references = [
			{
				uid: '',
				stateName: 'myApplications',
				dbName: 'myApplications',
				dispatchName: 'JobsState/GET_MYAPPLICATIONS',
				getJobs: true
			}
		];
		this.props.actions.getMyListener(references);
		// this.props.actions.getReferences(references)

		// firebase.auth().onAuthStateChanged((user)=>{
		//   if(user){
		//     this.getInfo(user.uid);
		//     this.setState({
		//       uid:user.uid,
		//       user:user.providerData[0],
		//       loggedIn:true,
		//       authLoading:false,
		//       loading:true,
		//       jobs:{},
		//       archives:{},
		//     })
		//   }
		//   else{
		//     firebase.database().ref(`myApplications/${this.state.uid}`).off()
		//     this.setState({
		//       loggedIn:false,
		//       authLoading:false,
		//       loading:true,
		//       user:{},
		//       uid:'',
		//       jobs:{},
		//       archives:{},
		//     })
		//   }
		// });
	}

	// componentWillUnmount(){
	//   firebase.database().ref(`myApplications/${this.state.uid}`).off()
	// }

	// getInfo=(uid)=>{
	//   const ref = firebase.database().ref();
	//   ref.child(`myApplications/${uid}`).orderByChild("archived").equalTo(null).limitToLast(this.state.getVolume).on('value',(snap)=>{
	//     if(snap.val()!==null){
	//       let counter = snap.numChildren();
	//       let {jobs} = this.state;
	//       //TODO: use lodash isEqual to check if snap.val() is equal to jobs Object, if so open snack to inform user no more jobs
	//       if(Object.keys(jobs).length===Object.keys(snap.val()).length){this.setState({snackStatus:true,snackMessage:'No more jobs to load.'})}
	//       snap.forEach(myJobSnap=>{
	//         let promises = [];
	//         if(!(myJobSnap.key in jobs)){
	//           const jobPromise = ref.child(`jobs/${myJobSnap.key}`).once('value').then(jobSnap=>{
	//             jobs[myJobSnap.key] = jobSnap.val();
	//             jobs[myJobSnap.key].oid = myJobSnap.val().oid;
	//             this.setState({jobs});
	//           })
	//           promises.push(jobPromise);
	//         }
	//         counter--;
	//         if(counter===0){
	//           Promise.all(promises).then(()=>{
	//             this.setState({
	//               loading:false,
	//               getVolume:(this.state.getVolume+this.state.getVolumeIncrement),
	//             })
	//           })
	//         }
	//       })
	//     }
	//     else {
	//       this.setState({
	//         snackStatus:true,
	//         snackMessage:'No more jobs to load.',
	//         jobs:{},
	//         loading:false,
	//       })
	//     }
	//   })
	// }

	// getArchives=(uid)=>{
	//   const ref = firebase.database().ref();
	//   ref.child(`myApplications/${uid}`).orderByChild("archived").equalTo(true).limitToLast(this.state.getVolumeArchives).once('value').then(snap=>{
	//     if(snap.val()!==null){
	//       let counter = snap.numChildren();
	//       let {archives} = this.state;
	//       //TODO: use lodash isEqual to check if snap.val() is equal to jobs Object, if so open snack to inform user no more jobs
	//       if(Object.keys(archives).length===Object.keys(snap.val()).length){this.setState({snackStatus:true,snackMessage:'No more jobs to load.'})}
	//       snap.forEach(myJobSnap=>{
	//         let promises = [];
	//         if(!(myJobSnap.key in archives)){
	//           const jobPromise = ref.child(`jobs/${myJobSnap.key}`).once('value').then(jobSnap=>{
	//             archives[myJobSnap.key] = jobSnap.val();
	//             archives[myJobSnap.key].oid = myJobSnap.val().oid;
	//             this.setState({archives})
	//           })
	//           promises.push(jobPromise);
	//         }
	//         counter--;
	//         if(counter===0){
	//           Promise.all(promises).then(()=>{
	//             this.setState({
	//               archiveLoading:false,
	//               getVolumeArchives:(this.state.getVolumeArchives+this.state.getVolumeIncrementArchives),
	//             })
	//           })
	//         }
	//       })
	//     }
	//     else {
	//       this.setState({
	//         snackStatus:true,
	//         snackMessage:'No more jobs to load.',
	//         archives:{},
	//         archiveLoading:false,
	//       })
	//     }
	//   })
	// }

	handleArchive = (jid, status) => {
		// const {jobs,archives} = this.state;
		const { uid } = this.props.user;
		firebase
			.database()
			.ref(`myApplications/${uid}/${jid}/`)
			.update({ archived: status })
			.then(() => {
				this.props.actions.setSnack(
					true,
					`Success: ${!!status ? 'archived' : 'unarchived'}.`
				);
			})
			.catch(() => {
				this.props.actions.setSnack(true, 'Error: Please try again.');
			});
		// .then(()=>{
		//   if(status){
		//     delete jobs[jid];
		//   }
		//   else{
		//     delete archives[jid];
		//     this.setState({viewArchived:false,archiveLoading:true})
		//   }
		//   this.setState({
		//     jobs,
		//     archives,
		//     snackStatus:true,
		//     snackMessage:`Job ${status?'archived':'unarchived'}.`
		//   })
		// })
		// .catch(err=>{
		//   this.setState({
		//     snackStatus:true,
		//     snackMessage:'Error: Job not archived'
		//   })
		//   console.log(err);
		// })
	};

	renderJobs = () => {
		const { jobs, myApplications } = this.props;
		// const {myApplications,jobs} = this.props;
		const { archives } = this.state;
		let jids = Object.keys(myApplications);
		let jobDetails = [];
		jids.forEach(jid => {
			if (!!this.props.jobs[jid]) {
				jobDetails.push(this.props.jobs[jid]);
			}
		});
		let html = [];
		// if (_.isEmpty(myApplications)) {
		if (
			_.isEmpty(myApplications) ||
			_.isEmpty(
				Object.keys(myApplications).filter(
					jid => !!myApplications[jid].archived === !!archives
				)
			)
		) {
			let card = (
				<EmptyState
					key="no applications"
					subject={'No Applications'}
					message={'Apply to a Job today.'}
					btnDestination={'/Invites'}
					btnMsg={'Invites'}
				/>
			);
			html.push(card);
			return html;
		} else {
			Object.keys(myApplications)
				.filter(jid => !!myApplications[jid].archived === !!archives)
				.filter(jid => !!jobs[jid])
				.map(jid => {
					let job = jobs[jid];
					job.oid = myApplications[jid].oid;
					return job;
				})
				.forEach(job => {
					let card = (
						<Fade key={job.jid} in={true}>
							<Card className="card">
								<JobCardHeader job={job} status={true} />
								<Divider light />
								{job.status === 'published' && (
									<JobCardContent job={job} wrap={true} />
								)}
								{job.status !== 'published' && (
									<UnpublishedJob status={job.status} />
								)}
								<CardActions className="cardActions">
									{!myApplications[job.jid].archived && (
										<Link
											className="cardActionsBtn"
											to={`/Offer/${myApplications[job.jid].oid}`}
										>
											<Button raised>Application</Button>
										</Link>
									)}

									{job.status !== 'published' &&
										!myApplications[job.jid].archived && (
											<Button
												className="cardActionsBtn"
												onClick={() => {
													this.handleArchive(job.jid, true);
												}}
												raised
												aria-label="Archive"
											>
												Archive
											</Button>
										)}
									{job.status !== 'published' &&
										!!myApplications[job.jid].archived && (
											<Button
												className="cardActionsBtn"
												onClick={() => {
													this.handleArchive(job.jid, false);
												}}
												raised
												aria-label="Unarchive"
											>
												Unarchive
											</Button>
										)}
								</CardActions>
							</Card>
						</Fade>
					);
					html.push(card);
				});
			if (html.length === 0) {
				let card = (
					<SkeletonCard
						key={'no_applications_yet'}
						header={true}
						content={true}
						actions={true}
					/>
				);
				// let card = <EmptyState key='no unarchived jobs' subject={'No Unarchived Jobs'} message={'Create a Job to start sharing and receiving applicants.'} btnDestination={'/AddJob'} btnMsg={'Add a Job'} />
				html.push(card);
				return html;
			}
			return html;
		}
	};

	// renderJobs=()=>{
	//   // const {jobs} = this.state;
	//   const {jobs,myApplications} = this.props;
	//   let html = [];
	//   if (Object.keys(myApplications).length===0) {
	//     let card = <EmptyState key='no applications' subject={'No Applications Made.'} message={'Start applying to available positions.'} btnDestination={'/'} btnMsg={'Home'} />
	//     html.push(card);
	//     return html;
	//   }
	//   else {
	//     let test = Object.keys(myApplications)
	//     //filter out myApplications that don't have jobs yet
	//     .filter(jid=>!!jobs[jid])
	//     //get the myApplications for each oid
	//     .map(jid=>myApplications[jid])
	//     // spread the job into the myApplications
	//     .map(application=>{
	//       let jid = application.jid
	//       return {...jobs[jid],...application}
	//     })
	//     console.log(test);
	//     test
	//     .forEach(job=>{
	//       // let job = jobs[jid];
	//       let card = (
	//         <Fade key={job.jid} in={true}>
	//           <Card className="card">
	//             <JobCardHeader job={job} />
	//             <Divider light />
	//             {job.status!=='published'?<UnpublishedJob status={job.status} />:<JobCardContent job={job} wrap={true} />}
	//             <CardActions className="cardActions">
	//               <Link className="cardActionsBtn" to={`/Offer/${job.oid}`} >
	//                 <Button raised >View Offer</Button>
	//               </Link>
	//               <Link className='cardActionsBtn' to={`/Offer/${job.oid}`} >
	//                 <Button raised >View Application</Button>
	//               </Link>
	//               {job.status!=='published'?<Button className="cardActionsBtn" onClick={()=>{this.handleArchive(job.jid,true)}} raised aria-label="Archive">Archive</Button>:null}
	//             </CardActions>
	//           </Card>
	//         </Fade>
	//       )
	//       html.push(card);
	//     })
	//     if(html.length===0){
	//       let card = <EmptyState key='no unarchived applications' subject={'No Unarchived Applications'} message={'Start applying to available positions.'} btnDestination={'/'} btnMsg={'Home'} />
	//       html.push(card);
	//       return html;
	//     }
	//     return html;
	//   }
	// }

	// closeSnack=()=>{
	//   this.setState({snackStatus:false,snackMessage:''})
	// }

	// handleViewArchivedBtnClick=(status)=>{
	//   this.setState({
	//     viewArchived:status,
	//   })
	//   if(status===true&&this.state.archives!==null&&Object.keys(this.state.archives).length===0){this.getArchives(this.state.uid);}
	// }

	// loadMore=(type)=>{
	//   const{uid}=this.state;
	//   if(type==='unarchived'){this.getInfo(uid)}
	//   if(type==='archives'){this.getArchives(uid)}
	// }

	// renderArchives=()=>{
	//   const {archives} = this.state;
	//   let html = [];
	//   let jids = Object.keys(archives);
	//   if(Object.keys(archives).length===0){
	//     html.push(<EmptyState key='no archived applications' subject={'No Archived Applications'} message={'Apply to a Job to start.'} btnDestination={'/'} btnMsg={'Home'} />)
	//   }
	//   else{
	//     jids.forEach(jid=>{
	//       let job = archives[jid];
	//       let card = (
	//         <Fade key={job.jid} in={true}>
	//           <Card className="card">
	//             <JobCardHeader job={job} />
	//             <Divider light />
	//             {job.status!=='published'?
	//               null
	//               :
	//               <JobCardContent job={job} wrap={true} />
	//             }
	//             {job.status!=='published'?<UnpublishedJob status={job.status} />:null}
	//             <CardActions className="cardActions">
	//               <Link className="cardActionsBtn" to={`/Offer/${job.oid}`} >
	//                 <Button raised >View Offer</Button>
	//               </Link>
	//               <Link className='cardActionsBtn' to={`/Offer/${job.oid}`} >
	//                 <Button raised >View Application</Button>
	//               </Link>
	//               {job.status!=='published'?<Button className="cardActionsBtn" onClick={()=>{this.handleArchive(job.jid,null)}} raised aria-label="Unarchive">Unarchive</Button>:null}
	//             </CardActions>
	//           </Card>
	//         </Fade>
	//       )
	//       html.push(card)
	//     })
	//   }
	//   if(html.length===0){
	//     let card = <EmptyState key='no unarchived applications' subject={'No Applications'} message={'Start applying today.'} btnDestination={'/'} btnMsg={'Home'} />
	//     html.push(card);
	//   }
	//   return html;
	// }

	handleTabChange = (e, value) => this.setState({ tab: value });

	renderTabs = () => {
		let html = [];
		let tabs = (
			<Tabs
				value={this.state.tab || 0}
				onChange={this.handleTabChange}
				indicatorColor="primary"
				textColor="primary"
				centered
				key="jobs_tabs"
			>
				<Tab
					onClick={() => {
						this.setState({ archives: false });
					}}
					label="Active"
				/>
				<Tab
					onClick={() => {
						this.setState({ archives: true });
					}}
					label="Archived"
				/>
			</Tabs>
		);
		html.push(tabs);
		return html;
	};

	render() {
		console.log(this.props);
		return (
			<React.Fragment>
				<Head title={`Applications | ${Title}`} />
				<div id={this.props.loggedIn ? 'loggedInBody' : null} className="body">
					{this.props.authLoading && (
						<CircularProgress style={style.loading} size={75} />
					)}

					{this.props.loggedIn &&
						!this.props.adminLoading &&
						!this.props.admin &&
						!this.props.myApplicationsLoading &&
						!this.props.jobsLoading &&
						this.renderTabs()}

					{!this.props.authLoading &&
						!this.props.adminLoading &&
						!this.props.admin &&
						this.props.loggedIn &&
						(this.props.myApplicationsLoading || this.props.jobsLoading) && (
							<SkeletonCard header={true} content={true} actions={true} />
						)}
					{this.props.loggedIn &&
						!this.props.adminLoading &&
						!this.props.admin &&
						!this.props.myApplicationsLoading &&
						!this.props.jobsLoading &&
						this.renderJobs()}

					{!this.props.authLoading &&
						this.props.loggedIn &&
						!this.props.adminLoading &&
						this.props.admin && (
							<div className="unauthorizedTextContainer">
								<UnauthorizedText
									text="Unauthorized"
									subText="Access is limited"
								/>
							</div>
						)}
					{!this.props.authLoading && !this.props.loggedIn && <LoggedOutCard />}
				</div>
			</React.Fragment>
		);
	}
}

// {this.state.loggedIn ?<ViewMoreFeedBtn key={'load more'} onClickfunction={()=>{this.loadMore('unarchived')}} text={'Load More'} />:null}
// {this.state.loggedIn && this.state.viewArchived?<ViewMoreFeedBtn key={'view more'} onClickfunction={()=>{this.handleViewArchivedBtnClick(false)}} text={'Hide Archived'} />:null}
// {this.state.loggedIn && !this.state.viewArchived?<ViewMoreFeedBtn key={'view more'} onClickfunction={()=>{this.handleViewArchivedBtnClick(true)}} text={'View Archived'} />:null}
// {this.state.loggedIn && this.state.viewArchived && this.state.archiveLoading?<CircularProgress style={style.loading} size={75} />:null}
// {this.state.loggedIn && this.state.viewArchived && !this.state.archiveLoading?this.renderArchives():null}
// {this.state.loggedIn && this.state.viewArchived && !this.state.archiveLoading &&  this.state.viewArchived ?<ViewMoreFeedBtn key={'load more archives'} onClickfunction={()=>{this.loadMore('archives')}} text={'Load More'} />:null}



// WEBPACK FOOTER //
// ./src/pages/Applications/Applications.js